import script from "./Calendario.vue?vue&type=script&setup=true&lang=js"
export * from "./Calendario.vue?vue&type=script&setup=true&lang=js"

import "./Calendario.vue?vue&type=style&index=0&id=da604e02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-da604e02"]])

export default __exports__